import { render, staticRenderFns } from "./icon-upload.vue?vue&type=template&id=18d482c0&scoped=true&"
import script from "./icon-upload.vue?vue&type=script&lang=js&"
export * from "./icon-upload.vue?vue&type=script&lang=js&"
import style0 from "./icon-upload.vue?vue&type=style&index=0&id=18d482c0&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d482c0",
  null
  
)

export default component.exports